import { useT } from './lib/i18n';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { useAuth } from './lib/auth';
import { Shell } from './components/Shell';
import { Login } from './pages/Login';
import { SetPassword } from './pages/SetPassword';
import { Home } from './pages/Home';
import { Users } from './pages/Users';
import { Account } from './pages/Account';
import { Settings } from './pages/Settings';
import { Bookings } from './pages/Bookings';
import { MissingInfo } from './pages/MissingInfo';
import { useSearchParams } from 'react-router';

/** The calendar now lives in Today (0.23); old links keep working. */
function CalendarRedirect() {
  const [params] = useSearchParams();
  const q = params.toString();
  return <Navigate to={`/${q ? `?${q}` : ''}`} replace />;
}
import { Planning } from './pages/Planning';
import { Locked } from './pages/Locked';
import { ImportHistory } from './pages/ImportHistory';
import { Integrations } from './pages/Integrations';
import { BdrSettings } from './pages/BdrSettings';
import { More } from './pages/More';

export function App() {
  const { me, loading, locked } = useAuth();
  const location = useLocation();
  const t = useT();
  const toLogin = `/login?next=${encodeURIComponent(location.pathname + location.search)}`;
  if (loading) return <div className="auth-page muted">{t('Loading…')}</div>;
  if (locked) return <Locked />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route element={me ? <Shell /> : <Navigate to={toLogin} replace />}>
        <Route index element={<Home />} />
        <Route path="account" element={<Account />} />
        <Route path="more" element={<More />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="bookings/missing" element={<MissingInfo />} />
        <Route path="calendar" element={<CalendarRedirect />} />
        <Route path="planning" element={<Planning key="tours" />} />
        <Route path="transfers" element={<Planning key="transfers" mode="transfers" />} />
        <Route path="settings" element={me?.user.role === 'direction' ? <Settings /> : <Navigate to="/" replace />} />
        <Route path="settings/:resource" element={me?.user.role === 'direction' ? <Settings /> : <Navigate to="/" replace />} />
        <Route path="users" element={me?.user.role === 'direction' ? <Users /> : <Navigate to="/" replace />} />
        <Route path="import-history" element={me?.owner ? <ImportHistory /> : <Navigate to="/" replace />} />
        <Route path="integrations" element={me?.owner ? <Integrations /> : <Navigate to="/" replace />} />
        <Route path="bdr-settings" element={me?.owner ? <BdrSettings /> : <Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
